class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', this.handleViewCartClick.bind(this));
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  async handleViewCartClick(evt) {
    const viewCartButton = evt.target.closest('#cart-notification-button');
    if (!viewCartButton) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    evt.preventDefault();

    try {
      await this.refreshCartDrawer(cartDrawer);
      this.close();
      cartDrawer.open(viewCartButton);
    } catch (error) {
      window.location.href = viewCartButton.href;
    }
  }

  async refreshCartDrawer(cartDrawer) {
    const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
    if (!response.ok) throw new Error('Cart drawer section request failed');

    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const sourceDrawer = html.querySelector('cart-drawer');
    const sourceInner = html.querySelector('cart-drawer .drawer__inner');
    const targetInner = cartDrawer.querySelector('.drawer__inner');

    if (!sourceDrawer || !sourceInner || !targetInner) throw new Error('Cart drawer section is missing');

    targetInner.replaceWith(sourceInner);
    cartDrawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));

    const newOverlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (newOverlay) {
      newOverlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
